import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import LogoMarquee from "@/components/site/LogoMarquee";
import Industries from "@/components/site/Industries";
import Services from "@/components/site/Services";
import CaseStudies from "@/components/site/CaseStudies";
import Stats from "@/components/site/Stats";
import Approach from "@/components/site/Approach";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Refunds from "@/pages/legal/Refunds";
import Disclosures from "@/pages/legal/Disclosures";

const Home = () => {
  const { hash, pathname } = useLocation();

  // Handle deep-link hashes (e.g. arriving at /#contact from another page)
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const el = document.getElementById(id);
    if (el) {
      // give layout a beat to settle
      setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    }
  }, [hash, pathname]);

  return (
    <div data-testid="home-page" className="bg-stone-50">
      <Nav />
      <main>
        <Hero />
        <LogoMarquee />
        <Industries />
        <Services />
        <CaseStudies />
        <Stats />
        <Approach />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

const ScrollToTopOnRoute = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOnRoute />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/legal/terms" element={<Terms />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/refunds" element={<Refunds />} />
          <Route path="/legal/disclosures" element={<Disclosures />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
